import {
  checkNewAppVersionInstalled,
  restoreDBEssentialsFromLocalStorage,
} from '$logic/client-device'

export default () => {
  checkNewAppVersionInstalled()
  restoreDBEssentialsFromLocalStorage()
}
